import * as React from 'react';
import * as styles from './styles.css';

export const PageLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <main className={styles['page']}>
      <div className={styles['container']}>{children}</div>
    </main>
  );
};
